import React from "react";
import style from "./event-host-card.module.css";
import eventImage from "../../images/logo.png";
import { TEventHost } from "../../types";

type Props = {
    host: TEventHost;
    title?: string;
    full?: boolean;
    onClick?: (host: TEventHost) => void;
};

const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const target = e.target as HTMLImageElement;
    target.src = eventImage;
};

const EventHostCard = ({ host, title, full = false, onClick }: Props) => {
    const photoUrl = host.image_urls?.avatar ?? host.image_urls?.small ?? host.photo_url;

    return (
        <button
            type="button"
            className={style.hostCard}
            onClick={() => onClick?.(host)}
            aria-label={`Показать информацию: ${host.full_name}`}
        >
            <div className={style.hostCardHead}>
                <div className={style.hostCardPhoto}>
                    {photoUrl && (
                        <img
                            src={photoUrl}
                            alt={host.full_name}
                            className={style.hostPhoto}
                            onError={handleImageError}
                        />
                    )}
                    {full && typeof host.rating === "number" && (
                        <div className={style.hostRating}>{host.rating.toFixed(1)}</div>
                    )}
                </div>
                <div className={style.hostText}>
                    {title && <div className={style.hostLabel}>{title}</div>}
                    <div className={style.hostName}>{host.full_name}</div>
                </div>
                <span className={style.hostArrow} aria-hidden="true">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                        <path d="M1 1L7 7L1 13" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
            </div>
        </button>
    );
};

export default EventHostCard;
